(ns quuppa.qsm.deployment.events
  (:require [clojure.set :as set]
            [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.ui-state.events :as ui-state]))

(def deployments-query
  (q/create-query :deployment/list-deployments [:site-plan-key]))

(rf/reg-event-db :deployment/add
  (q/update-event-fn deployments-query
                     (fn [result event]
                       ;; FIXME: List uses kebab-case, maybe create should also use it?
                       (conj result (set/rename-keys (:deployment event)
                                                     {:target_email :target-email
                                                      :expiry_date :expiry-date})))))

(rf/reg-event-db :deployment/remove
  (q/update-event-fn deployments-query
                     (fn [result event]
                       (into (empty result) (remove #(= (:id %) (:id event)) result)))))

(rf/reg-event-fx
  :deployment/create-deployment
  (fn [{:keys [db]} [_ form-key site-plan-key]]
    (let [form (get-in db [:ui-state :site :sidebar form-key])]
      {:fx [[:server-dispatch {:event [:deployment/create-deployment (merge {:description ""
                                                                             ;; site-plan-key could come from Site plan
                                                                             ;; data as 'prefilled' by default, but if
                                                                             ;; site-plan-key exists in form data,
                                                                             ;; it will win the merge
                                                                             :site-plan-key site-plan-key}
                                                                            form)]
                               :on-success [:deployment/deployment-created]
                               :on-error   [:deployment/deployment-create-failed]}]]})))

(rf/reg-event-fx
  :deployment/deployment-create-failed
  (fn [_ [_ error]]
    {:fx [[:dispatch [::ui-state/update :site assoc-in [:sidebar :error] error]]]}))

(rf/reg-event-fx
  :deployment/deployment-created
  (fn [_ [_ _resp]]
    ;; TODO: show success?
    {:fx [[:dispatch [::ui-state/close-sidebar :site]]]}))

(rf/reg-event-fx
  :deployment/delete-deployment
  (fn [_ [_ site-plan-key id]]
    {:fx [[:server-dispatch {:event      [:deployment/delete-deployment {:id id}]
                             :on-success [:deployment/deployment-deleted site-plan-key]}]]}))

(rf/reg-event-fx
  :deployment/deployment-deleted
  (fn [_ [_ site-plan-key _resp]]
    {:fx [[::q/execute [deployments-query {:site-plan-key site-plan-key}]]]}))
